import { render, staticRenderFns } from "./StationSlide.vue?vue&type=template&id=916a860e"
import script from "./StationSlide.vue?vue&type=script&lang=js"
export * from "./StationSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('916a860e')) {
      api.createRecord('916a860e', component.options)
    } else {
      api.reload('916a860e', component.options)
    }
    module.hot.accept("./StationSlide.vue?vue&type=template&id=916a860e", function () {
      api.rerender('916a860e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/StationSlide.vue"
export default component.exports